(() => {
  'use strict';
  if (window.__smqvStandaloneR1) return;
  window.__smqvStandaloneR1 = true;
  const rootPath = window.Shopify?.routes?.root || '/';
  const products = new Map();
  const maps = new Map();
  let modal, zoom, current, sequence = 0, opener, submitting = false;
  let ratingVisibilityObserver = null, ratingVisibilityFrame = 0;
  let armedCard = null;
  function clearCardArm() {
    if (armedCard) {
      armedCard.classList.remove('smqv-controls-armed');
      const control = armedCard.querySelector('[data-smqv-handle]');
      if (control) ['opacity','visibility','pointer-events','display'].forEach(name => control.style.removeProperty(name));
    }
    armedCard = null;
  }
  function armCard(card) {
    clearCardArm(); armedCard = card; card.classList.add('smqv-controls-armed');
    const control = card.querySelector('[data-smqv-handle]');
    if (control) {
      control.style.setProperty('opacity','1','important');
      control.style.setProperty('visibility','visible','important');
      control.style.setProperty('pointer-events','auto','important');
      control.style.setProperty('display','flex','important');
    }
  }
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:window.Shopify?.currency?.active || 'USD'}).format(cents / 100);
  const safeImage = value => {
    const src = typeof value === 'string' ? value : value?.preview_image?.src || value?.src || '';
    if (!src) return '';
    try { const url = new URL(src, location.origin); return url.protocol === 'https:' ? url.href : ''; } catch (_) { return ''; }
  };
  function readMap(doc, handle) {
    for (const node of doc.querySelectorAll('script.rio-variant-map[data-product-handle]')) {
      if (node.dataset.productHandle !== handle) continue;
      try { const map = JSON.parse(node.textContent); if (Array.isArray(map.mapping)) return map; } catch (_) {}
    }
    return null;
  }
  async function fetchProduct(handle) {
    if (!products.has(handle)) {
      products.set(handle, fetch(rootPath + 'products/' + encodeURIComponent(handle) + '.js', {credentials:'same-origin', signal:AbortSignal.timeout(15000)})
        .then(response => { if (!response.ok) throw new Error('Could not load this product.'); return response.json(); })
        .catch(error => { products.delete(handle); throw error; }));
    }
    return products.get(handle);
  }
  async function fetchMap(handle) {
    const inline = readMap(document, handle);
    if (inline) { maps.set(handle, Promise.resolve(inline)); return inline; }
    if (!maps.has(handle)) {
      maps.set(handle, fetch(rootPath + 'products/' + encodeURIComponent(handle), {credentials:'same-origin', signal:AbortSignal.timeout(15000)})
        .then(response => { if (!response.ok) return null; return response.text(); })
        .then(html => html ? readMap(new DOMParser().parseFromString(html, 'text/html'), handle) : null)
        .catch(() => { maps.delete(handle); return null; }));
    }
    return maps.get(handle);
  }
  // Match the original QuickView's device sizing without its DOM observers.
  function syncDeviceLayout() {
    if (!modal) return;
    const width = window.innerWidth;
    const height = window.innerHeight;
    const landscape = width > height;
    const ua = navigator.userAgent || '';
    const touch = navigator.maxTouchPoints > 0;
    const windowsTouch = /Windows/i.test(ua) && touch;
    const ipad = /iPad/i.test(ua) || (/Mac/i.test(navigator.platform || '') && touch);
    const simulatedIpadPortrait = !landscape && !windowsTouch && touch && width >= 768 && width <= 1366 && height >= 1000 && height <= 1400;
    let layout = 'desktop', modalWidth = '40vw', shift = '0px';
    if (landscape && height < 600) {
      layout = 'phone-landscape'; modalWidth = '92vw'; shift = '20px';
    } else if (!landscape && width <= 599) {
      layout = 'phone-portrait'; modalWidth = '98vw'; shift = width > 375 ? '2px' : '0px';
    } else if (!landscape && windowsTouch && width >= 768) {
      layout = 'surface-portrait'; modalWidth = '70vw';
    } else if (!landscape && (ipad || simulatedIpadPortrait)) {
      layout = 'ipad-portrait'; modalWidth = '90vw';
    } else if (ipad) {
      layout = 'tablet-landscape'; modalWidth = '90vw'; shift = '50px';
    } else if (landscape && (window.screen?.width || width) <= 1600 && height <= 1024) {
      layout = 'tablet-landscape'; modalWidth = '80vw'; shift = width >= 768 ? '50px' : '0px';
    } else if (!landscape && width >= 768 && (window.screen?.height || height) <= 1600) {
      layout = 'tablet-portrait'; modalWidth = '70vw';
    }
    modal.dataset.smqvLayout = layout;
    modal.style.setProperty('--smqv-visible-height',(window.visualViewport?.height || height)+'px');
    modal.style.setProperty('--smqv-visible-top',(window.visualViewport?.offsetTop || 0)+'px');
    modal.style.setProperty('--smqv-device-width', modalWidth);
    modal.style.setProperty('--smqv-device-shift', shift);
  }
  window.addEventListener('resize', () => { if (modal?.open) { syncDeviceLayout(); centerThumbnails(); scheduleRatingVisibility(); } }, {passive:true});
  window.visualViewport?.addEventListener('resize', () => { if (modal?.open) { syncDeviceLayout(); centerThumbnails(); scheduleRatingVisibility(); } }, {passive:true});
  window.visualViewport?.addEventListener('scroll', () => { if (modal?.open) syncDeviceLayout(); }, {passive:true});
  function ensureModal() {
    if (modal) return;
    modal = document.createElement('dialog');
    modal.id = 'smqv-root';
    modal.className = 'smqv-app smqv-lightbox smqv-modal-overlay';
    modal.setAttribute('aria-label', 'Product quick view');
    modal.tabIndex = -1;
    modal.addEventListener('click', event => { if (event.target === modal) close(); });
    modal.addEventListener('cancel', event => { event.preventDefault(); close(); });
    modal.addEventListener('click', handleModalClick);
    modal.addEventListener('change', handleChange);
    let touchX = null;
    modal.addEventListener('touchstart', event => { if (event.target.closest('.smqv-main-img')) touchX = event.touches[0].clientX; }, {passive:true});
    modal.addEventListener('touchend', event => { if (touchX === null || !current) return; const delta = touchX - event.changedTouches[0].clientX; touchX = null; if (Math.abs(delta) > 40) selectImage(current.index + (delta > 0 ? 1 : -1)); }, {passive:true});
    document.body.appendChild(modal);
  }
  function shell(content) {
    modal.removeAttribute('aria-labelledby');
    modal.innerHTML = `<div class="smqv-modal-box smqv-modal"><div class="smqv-lightbox-wrapper smlightbox"><div class="smlightbox__header"><button type="button" class="smlightbox__close" data-smqv-close aria-label="Close quick view"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4 4l12 12M16 4L4 16" fill="none" stroke="currentColor" stroke-width="2"/></svg></button></div>${content}</div></div>`;
  }
  function close() {
    stopRatingVisibility();
    modal?.removeAttribute('data-smqv-needs-scroll');
    clearCardArm();
    sequence++;
    current = null;
    if (zoom?.__smqvCleanup) zoom.__smqvCleanup();
    else if (zoom?.open) zoom.close();
    if (modal?.open) modal.close();
    opener?.focus?.({preventScroll:true});
  }
  function setTriggerLoading(trigger, loading) {
    if (!trigger) return;
    if (loading) {
      trigger.dataset.smqvLoading = 'true';
      trigger.setAttribute('aria-busy','true');
      trigger.disabled = true;
      let dots = trigger.querySelector('.smqv-icon-ellipsis');
      if (!dots) { dots = document.createElement('span'); dots.className = 'smqv-icon-ellipsis'; dots.setAttribute('aria-hidden','true'); dots.textContent = '...'; trigger.appendChild(dots); }
    } else {
      delete trigger.dataset.smqvLoading;
      trigger.removeAttribute('aria-busy');
      trigger.disabled = false;
    }
  }
  async function open(handle, variantId, trigger) {
    clearCardArm();
    ensureModal();
    const token = ++sequence;
    opener = trigger;
    setTriggerLoading(trigger,true);
    current = null;
    shell('<p class="smqv-status" role="status">Loading product…</p>');
    // Show the loading dots on the card before opening the loaded modal.
    try {
      const [product, rio] = await Promise.all([fetchProduct(handle), fetchMap(handle)]);
      if (token !== sequence) return;
      const variants = product.variants || [];
      const selected = variants.find(v => String(v.id) === String(variantId)) || variants.find(v => v.available) || variants[0];
      if (!selected) throw new Error('No product variants are available.');
      current = {product, handle, rio, selected, index:0, media:[], trigger};
      syncDeviceLayout();
      if (!modal.open) modal.showModal();
      renderProduct();
    } catch (error) {
      if (token !== sequence) return;
      shell(`<p class="smqv-status" role="alert">${escape(error.message || 'Could not load product.')}</p><a class="smqv-full-link" href="${escape(rootPath + 'products/' + encodeURIComponent(handle))}">View product</a>`);
      if (!modal.open) modal.showModal();
    } finally {
      setTriggerLoading(trigger,false);
    }
  }
  function renderProduct() {
    const {product, selected} = current;
    const options = (product.options || []).map(option => typeof option === 'string' ? option : option.name);
    const fields = options.map((name, index) => {
      const values = [...new Set(product.variants.map(v => v.options?.[index] ?? v['option' + (index + 1)]))];
      if (name === 'Title' && values.length === 1 && values[0] === 'Default Title') return '';
      return `<div class="smqv-field smqv-option"><label class="smqv-option__title" for="smqv-option-${index}">${escape(name)}</label><div class="smqv-select"><select id="smqv-option-${index}" data-smqv-option="${index}">${values.map(value => `<option value="${escape(value)}"${value === (selected.options?.[index] ?? selected['option' + (index + 1)]) ? ' selected' : ''}>${escape(value)}</option>`).join('')}</select></div></div>`;
    }).join('');
    shell(`<div id="smqv-rio-gallery"><div class="smqv-main-img"><img id="smqv-main" alt="${escape(product.title)}" data-smqv-zoom></div><div class="smqv-thumbs-wrapper"><button class="smqv-chev smqv-chev-left" type="button" data-smqv-step="-1" aria-label="Previous image">‹</button><div class="smqv-thumbs"></div><button class="smqv-chev smqv-chev-right" type="button" data-smqv-step="1" aria-label="Next image">›</button></div></div>
      <div class="smlightbox__body"><div class="smqv-product product-layout--right product-image-size--sm"><div class="smqv-product__body"><div class="smqv-main"><div class="smqv-main-content">
      <div class="smqv-block smqv-block--title"><h3 class="smqv-title" id="smqv-title"><a data-smqv-product-link>${escape(product.title)}</a></h3></div><div data-smqv-rating></div>
      <div class="smqv-block smqv-block--price"><div class="smqv-atts smqv-price"><span class="smqv-price__current"></span><s class="smqv-price__regular"></s></div></div>
      <div class="smqv-block smqv-block--description smqv-block--description--show-mobile"><div class="smqv-atts smqv-description"><div class="smqv-description__main" hidden></div><div class="smqv-description__footer"><button type="button" data-smqv-description aria-expanded="false">Click for Description</button></div></div></div>
      <div class="smqv-block smqv-form"><div class="smqv-variants smqv-block"><div class="smqv-fields">${fields}</div></div>
      <div class="smqv-input-quantity smqv-block"><label class="smqv-field__title" for="smqv-quantity">Quantity</label><div class="smqv-input-group"><span role="button" tabindex="0" data-smqv-quantity-step="-1" aria-label="Decrease quantity">−</span><input id="smqv-quantity" class="smqv-input" type="number" inputmode="numeric" min="1" step="1" value="1"><span role="button" tabindex="0" data-smqv-quantity-step="1" aria-label="Increase quantity">+</span></div></div>
      <div class="smqv-buttons smqv-block"><div class="smqv-btn-wrap"><button type="button" class="smqv-btn smqv-btn-addtocart" data-smqv-add>Add to Cart</button><button type="button" class="smqv-wishlist" data-smqv-wishlist aria-label="Add selected variant to wishlist" aria-pressed="false"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.8-7.5 1.1-1.1a5.5 5.5 0 0 0-.1-7.8Z"/></svg></button><a href="javascript:void(0)" role="presentation" class="iWishAddColl iwishcheck smqv-wishlist-native" aria-hidden="true" tabindex="-1"></a></div><p class="smqv-response" role="status"></p></div></div>
      </div></div></div></div></div>`);
    modal.setAttribute('aria-labelledby', 'smqv-title');
    const description = modal.querySelector('.smqv-description__main');
    const parsed = new DOMParser().parseFromString(product.description || '', 'text/html');
    parsed.querySelectorAll('script,style,iframe,object,embed,form').forEach(node => node.remove());
    parsed.querySelectorAll('*').forEach(node => {
      [...node.attributes].forEach(attr => { if (/^on/i.test(attr.name) || /^(href|src)$/i.test(attr.name) && /^\s*javascript:/i.test(attr.value)) node.removeAttribute(attr.name); });
      // Landscape sizing overrides inline typography; other screens retain its original values.
      for (const property of ['font-size','line-height']) {
        const value = node.style?.getPropertyValue(property);
        if (!value) continue;
        const priority = node.style.getPropertyPriority(property);
        node.style.setProperty(property, 'var(--smqv-landscape-description-' + property + ', ' + value + ')', priority);
      }
    });
    description.innerHTML = parsed.body.innerHTML;
    const sourceRating = current.trigger?.closest('product-card')?.querySelector('.trustshop-collection-rating--item');
    if (sourceRating) {
      const copy = sourceRating.cloneNode(true);
      copy.classList.remove('slickmod-qv-trustshop');
      copy.setAttribute('product-id',String(product.id));
      const ratingControl = modal.querySelector('[data-smqv-rating]');
      ratingControl.setAttribute('role','button'); ratingControl.tabIndex = 0;
      ratingControl.setAttribute('aria-label','View customer reviews'); ratingControl.style.cursor = 'pointer';
      copy.querySelectorAll('[id]').forEach(node => node.id = 'smqv-' + node.id);
      copy.querySelectorAll('[fill]').forEach(node => { const fill = node.getAttribute('fill'); if (fill?.startsWith('url(#')) node.setAttribute('fill', fill.replace('url(#', 'url(#smqv-')); });
      modal.querySelector('[data-smqv-rating]').appendChild(copy);
    }
    // Restore product-specific ratings for cards without native product-card stars.
    if (!sourceRating || !sourceRating.querySelector('svg')) {
      const ratingModal = modal;
      const ratingProduct = current;
      const ratingToken = sequence;
      fetch('https://storefront.trustshop.io/storefront/page/summary?shop_id=4956749927&product_ids=' + encodeURIComponent(product.id))
        .then(response => {
          if (!response.ok) throw new Error('Rating request failed');
          return response.json();
        })
        .then(summary => {
          if (sequence !== ratingToken || current !== ratingProduct || modal !== ratingModal || !ratingModal.open) return;
          const total = Number(summary?.total_review);
          const average = Number(summary?.average_review);
          if (!(total > 0) || !Number.isFinite(average) || average < 0 || average > 5) return;
          const holder = ratingModal.querySelector('[data-smqv-rating]');
          if (!holder || hasVisibleRatingStars(holder)) return;
          holder.setAttribute('role', 'button');
          holder.tabIndex = 0;
          holder.setAttribute('aria-label', average.toFixed(1) + ' out of 5 stars, ' + total + ' reviews. View customer reviews');
          holder.style.cursor = 'pointer';
          const stars = document.createElement('span');
          stars.setAttribute('product-id', String(product.id));
          stars.style.cssText = 'display:inline-flex;align-items:center;gap:2px;position:relative;left:6px;top:-1px;';
          for (let index = 0; index < 5; index++) {
            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('viewBox', '0 0 24 24');
            svg.setAttribute('width', '17');
            svg.setAttribute('height', '17');
            svg.style.flexShrink = '0';
            svg.setAttribute('aria-hidden', 'true');
            const id = 'smqv-rating-' + ratingToken + '-' + index;
            const fill = Math.max(0, Math.min(1, average - index)) * 100;
            svg.innerHTML = '<defs><linearGradient id="' + id + '"><stop offset="' + fill + '%" stop-color="#FFB400"/><stop offset="' + fill + '%" stop-color="#ddd"/></linearGradient></defs><path fill="url(#' + id + ')" d="m12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14l-5-4.87 6.91-1.01Z"/>';
            stars.append(svg);
          }
          const count = document.createElement('span');
          count.textContent = '(' + total + ')';
          count.style.cssText = 'font-size:11px;margin-left:3px;';
          stars.append(count);
          holder.replaceChildren(stars);
          scheduleRatingVisibility();
        })
        .catch(error => console.warn('SlickMod QuickView rating unavailable', error));
    }
    updateVariant();
    watchRatingVisibility();
    modal.focus({preventScroll:true});
  }
  function stopRatingVisibility() {
    ratingVisibilityObserver?.disconnect(); ratingVisibilityObserver = null;
    cancelAnimationFrame(ratingVisibilityFrame); ratingVisibilityFrame = 0;
  }
  function watchRatingVisibility() {
    stopRatingVisibility();
    const holder = modal.querySelector('[data-smqv-rating]');
    if (holder && window.MutationObserver) {
      ratingVisibilityObserver = new MutationObserver(scheduleRatingVisibility);
      ratingVisibilityObserver.observe(holder,{childList:true,subtree:true,attributes:true,attributeFilter:['style','class','hidden','width','height','fill','stroke','d']});
    }
    scheduleRatingVisibility();
  }
  function hasVisibleRatingStars(holder) {
    if (!holder) return false;
    return Array.from(holder.querySelectorAll('svg')).some(svg => {
      const rect = svg.getBoundingClientRect();
      if (rect.width <= 0 || rect.height <= 0) return false;
      return Array.from(svg.querySelectorAll('path,polygon,use,rect,circle,ellipse')).some(shape => {
        const bounds = shape.getBoundingClientRect();
        if (bounds.width <= 0 || bounds.height <= 0) return false;
        for (let node = shape; node && node !== holder.parentElement; node = node.parentElement) {
          const style = window.getComputedStyle(node);
          if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || parseFloat(style.opacity) === 0) return false;
        }
        const style = window.getComputedStyle(shape);
        return [style.fill,style.stroke].some(paint => paint && paint !== 'none' && paint !== 'transparent' && !/^rgba\([^)]*,\s*0(?:\.0+)?\)$/.test(paint));
      });
    });
  }
  function scheduleRatingVisibility() {
    cancelAnimationFrame(ratingVisibilityFrame);
    ratingVisibilityFrame = requestAnimationFrame(() => {
      if (!modal?.open || !current) return;
      const price = modal.querySelector('.smqv-price');
      if (!price) return;
      const noStars = String(!hasVisibleRatingStars(modal.querySelector('[data-smqv-rating]')));
      if (price.dataset.smqvNoStars !== noStars) price.dataset.smqvNoStars = noStars;
    });
  }
  function updateVariant() {
    if (!current) return;
    const {product, selected, handle, rio} = current;
    modal.querySelector('.smqv-price__current').textContent = money(selected.price);
    const compare = modal.querySelector('.smqv-price__regular');
    compare.hidden = !(selected.compare_at_price > selected.price);
    compare.textContent = compare.hidden ? '' : money(selected.compare_at_price);
    const button = modal.querySelector('[data-smqv-add]');
    button.disabled = !selected.available || submitting;
    if (!submitting) button.textContent = selected.available ? 'Add to Cart' : 'Sold out';
    const link = modal.querySelector('[data-smqv-product-link]');
    link.href = rootPath + 'products/' + encodeURIComponent(handle) + '?variant=' + selected.id;
    syncModalWishlist();
    const entry = rio?.mapping?.find(item => String(item.id) === String(selected.id));
    const media = (product.media || []).filter(m => m.media_type === 'image' || !m.media_type);
    const allowed = entry?.media?.length ? new Set(entry.media.map(String)) : null;
    let visible = allowed ? media.filter(m => allowed.has(String(m.id))) : media;
    if (!visible.length) visible = media.length ? media : (product.images || []).map(src => ({src}));
    current.media = visible.map(item => ({src:safeImage(item),alt:item.alt || product.title})).filter(item => item.src);
    current.index = 0;
    const thumbs = modal.querySelector('.smqv-thumbs');
    thumbs.innerHTML = current.media.map((item, index) => `<button type="button" class="smqv-thumb-button" data-smqv-image="${index}" aria-label="View image ${index + 1}"><img src="${escape(item.src)}" alt="${escape(item.alt)}" loading="lazy" class="${index === 0 ? 'active' : ''}"></button>`).join('');
    selectImage(0);
    centerThumbnails();
  }
  function syncShortPortraitScroll() {
    if (!modal?.open) return;
    const portrait = window.matchMedia('(max-width:599px) and (orientation:portrait)').matches;
    const panel = modal.querySelector('.smlightbox');
    const body = panel?.querySelector('.smlightbox__body');
    const contentHeight = panel ? Math.max(panel.scrollHeight,body ? body.offsetTop + body.offsetHeight : 0) : 0;
    const needsScroll = portrait && panel && contentHeight > panel.clientHeight + 1;
    if (needsScroll) modal.setAttribute('data-smqv-needs-scroll','true');
    else modal.removeAttribute('data-smqv-needs-scroll');
  }
  function centerThumbnails() {
    const track = modal?.querySelector('.smqv-thumbs');
    if (!track) return;
    cancelAnimationFrame(track.__smqvCenterFrame || 0);
    track.__smqvCenterFrame = requestAnimationFrame(() => {
      if (!track.isConnected || !modal?.open) return;
      const buttons = Array.from(track.querySelectorAll('.smqv-thumb-button'));
      if (!buttons.length) return;
      const style = window.getComputedStyle(track);
      const gap = parseFloat(style.columnGap || style.gap) || 0;
      const rowWidth = buttons.reduce((total,button) => total + button.offsetWidth,0) + gap * Math.max(0,buttons.length-1);
      const fits = rowWidth <= track.clientWidth + 1;
      track.style.setProperty('justify-content',fits ? 'center' : 'flex-start','important');
      track.style.setProperty('padding-left',fits ? '0px' : '10px','important');
      track.style.setProperty('padding-right',fits ? '0px' : '36px','important');
      track.scrollLeft = 0;
      revealSelectedThumbnail();
      syncShortPortraitScroll();
    });
  }
  function selectImage(index) {
    if (!current?.media.length) return;
    current.index = (index + current.media.length) % current.media.length;
    const image = modal.querySelector('#smqv-main');
    image.src = current.media[current.index].src;
    image.alt = current.media[current.index].alt;
    modal.querySelectorAll('[data-smqv-image]').forEach((button, i) => { button.setAttribute('aria-pressed', String(i === current.index)); button.querySelector('img').classList.toggle('active', i === current.index); });
    revealSelectedThumbnail();
  }
  function revealSelectedThumbnail() {
    if (!current) return;
    const active = modal.querySelector(`[data-smqv-image="${current.index}"]`);
    const track = modal.querySelector('.smqv-thumbs');
    if (active && track) {
      const left = active.offsetLeft - track.offsetLeft;
      const right = left + active.offsetWidth;
      if (left < track.scrollLeft) track.scrollLeft = left;
      else if (right > track.scrollLeft + track.clientWidth) track.scrollLeft = right - track.clientWidth;
    }
  }
  function handleChange(event) {
    if (!current || !event.target.matches('[data-smqv-option]')) return;
    const choices = (current.selected.options || []).slice();
    modal.querySelectorAll('[data-smqv-option]').forEach(select => choices[Number(select.dataset.smqvOption)] = select.value);
    const next = current.product.variants.find(v => choices.every((value, index) => (v.options?.[index] ?? v['option' + (index + 1)]) === value));
    if (!next) { modal.querySelector('[data-smqv-add]').disabled = true; modal.querySelector('.smqv-response').textContent = 'This combination is unavailable.'; return; }
    current.selected = next;
    modal.querySelector('.smqv-response').textContent = '';
    updateVariant();
  }
  function syncModalWishlist() {
    if (!current) return;
    const native = modal.querySelector('.smqv-wishlist-native');
    const button = modal.querySelector('[data-smqv-wishlist]');
    if (!native || !button) return;
    const variantId = String(current.selected.id);
    if (native.dataset.variant !== variantId) native.classList.remove('iwishAdded');
    if (native.getAttribute('data-product') !== String(current.product.id)) native.setAttribute('data-product',String(current.product.id));
    if (native.getAttribute('data-variant') !== variantId) native.setAttribute('data-variant',variantId);
    if (native.getAttribute('data-pTitle') !== current.product.title) native.setAttribute('data-pTitle',current.product.title);
    const api = typeof iWish !== 'undefined' ? iWish : window.iWish;
    let added = native.classList.contains('iwishAdded');
    if (typeof api?.isInWishlist === 'function') {
      try { added = Boolean(api.isInWishlist(variantId)); } catch (_) {}
    }
    button.setAttribute('aria-pressed',String(added));
    button.setAttribute('aria-label',added ? 'Remove selected variant from wishlist' : 'Add selected variant to wishlist');
    button.title = added ? 'Remove from wishlist' : 'Add to wishlist';
  }
  function toggleModalWishlist() {
    if (!current) return;
    syncModalWishlist();
    const native = modal.querySelector('.smqv-wishlist-native');
    const api = window.iWish;
    const status = modal.querySelector('.smqv-response');
    const required = ['isInWishlist','iwishAdd','iwishRemove','setIwishAdded','setIwishRemoved'];
    if (!native || !api || required.some(name => typeof api[name] !== 'function')) {
      status.textContent = 'Wishlist is still loading. Please try again.';
      return;
    }
    const token = sequence;
    const variantId = String(current.selected.id);
    const productId = String(current.product.id);
    const quantity = Math.max(1,parseInt(modal.querySelector('#smqv-quantity')?.value,10) || 1);
    const removing = api.isInWishlist(variantId);
    try {
      // Same toggle branch and app calls as the supplied iWish click handler.
      // No native.click(), duplicate listeners or observer feedback loop.
      if (window.changeDetect) window.changeDetect.status = '';
      if (window.iwishAddProxy) window.iwishAddProxy.click = 'true';
      let result;
      if (removing) {
        result = api.iwishRemove(variantId,productId);
        api.setIwishRemoved(native);
        if (window.changeDetect) window.changeDetect.status = 'removed';
      } else {
        result = api.iwishAdd(variantId,productId,quantity);
        api.setIwishAdded(native);
        if (window.changeDetect) window.changeDetect.status = 'added';
      }
      status.textContent = '';
      const refresh = () => {
        if (sequence === token && current && String(current.selected.id) === variantId) syncModalWishlist();
      };
      refresh();
      window.setTimeout(refresh,700);
      if (result && typeof result.then === 'function') {
        Promise.resolve(result).then(refresh).catch(() => {
          if (sequence === token && current) { status.textContent = 'Could not update your wishlist. Please try again.'; refresh(); }
        });
      }
    } catch (error) {
      status.textContent = 'Could not update your wishlist. Please try again.';
      console.warn('SlickMod QuickView wishlist toggle failed',error);
    }
  }
  // Original ui-custom.js expanded gallery, adapted to a native dialog.
  // Same image/chevron/swipe/zoom behavior on every screen; no thumbnails.
  function showZoom() {
    if (!current?.media.length) return;
    openZoomOverlay(current.media,current.index);
  }
  function openZoomOverlay(mediaList, startIdx) {
    var existing = document.getElementById('smqv-zoom');
    if (existing) { existing.__smqvCleanup?.(); if (existing.open) existing.close(); existing.remove(); }
    var lifecycle = new AbortController();
    var cleaned = false;
    var idx = startIdx || 0;
    var zoomViewportWidth = window.innerWidth, zoomViewportHeight = window.innerHeight;
    var srcs = mediaList.map(function (m) { return (m.src || '').split('?')[0]; });

    var overlay = document.createElement('dialog');
    overlay.id = 'smqv-zoom';
    overlay.setAttribute('aria-label','Product image zoom');
    zoom = overlay;
    function cleanupZoom() {
      if (cleaned) return;
      cleaned = true;
      lifecycle.abort();
      if (overlay.open) overlay.close();
      overlay.remove();
      if (zoom === overlay) zoom = null;
    }
    overlay.__smqvCleanup = cleanupZoom;
    overlay.addEventListener('close',cleanupZoom,{once:true});
    overlay.addEventListener('cancel',function(e) { e.preventDefault(); if (scale > 1) resetZoom(true); else cleanupZoom(); });
    overlay.style.cssText = 'position:fixed;inset:0;z-index:99999999;background:rgba(0,0,0,0.92);padding:0;border:0;margin:0;max-width:none;max-height:none;display:flex;align-items:center;justify-content:center;overflow:hidden;touch-action:none;';

    var closeBtn = document.createElement('div');
    closeBtn.innerHTML = '&times;';
    closeBtn.style.cssText = 'position:absolute;top:16px;right:20px;font-size:36px;color:#fff;cursor:pointer;line-height:1;z-index:10;user-select:none;';

    var scale = 1, translateX = 0, translateY = 0;
    var minScale = 1, maxScale = 5;
    var isDragging = false, dragStartX = 0, dragStartY = 0, dragOriginX = 0, dragOriginY = 0;
    var isPinching = false, pinchStartDist = 0, pinchStartScale = 1, pinchOriginX = 0, pinchOriginY = 0;
    var swipeTouchStartX = 0, swipeTouchStartY = 0;

    var img = document.createElement('img');
    img.style.cssText = [
      'display:block', 'width:88vw', 'height:88vh', 'object-fit:contain',
      'border-radius:4px', 'cursor:zoom-in', 'transform-origin:center center',
      'position:relative', 'z-index:2', 'will-change:transform',
      'user-select:none', '-webkit-user-drag:none'
    ].join(';');

    function applyTransform(animated) {
      img.style.transition = animated ? 'transform 0.25s ease' : 'none';
      img.style.transform = 'translate(' + translateX + 'px,' + translateY + 'px) scale(' + scale + ')';
      img.style.cursor = scale > 1 ? 'grab' : 'zoom-in';
    }

    function resetZoom(animated) {
      scale = 1; translateX = 0; translateY = 0;
      applyTransform(animated);
    }

    function clampTranslate() {
      var maxX = (88 * zoomViewportWidth / 100) * (scale - 1) / 2;
      var maxY = (88 * zoomViewportHeight / 100) * (scale - 1) / 2;
      translateX = Math.min(maxX, Math.max(-maxX, translateX));
      translateY = Math.min(maxY, Math.max(-maxY, translateY));
    }

    function getTouchDist(t1, t2) {
      var dx = t1.clientX - t2.clientX, dy = t1.clientY - t2.clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function getTouchMid(t1, t2) {
      return { x: (t1.clientX + t2.clientX) / 2, y: (t1.clientY + t2.clientY) / 2 };
    }

    var lastTap = 0;
    img.addEventListener('click', function (e) {
      e.stopPropagation();
      var now = Date.now(), timeSince = now - lastTap;
      if (timeSince < 300 && timeSince > 0) {
        if (scale > 1) { resetZoom(true); } else { scale = 2.5; translateX = 0; translateY = 0; applyTransform(true); }
        lastTap = 0;
      } else { lastTap = now; }
    });

    img.addEventListener('mousedown', function (e) {
      if (scale <= 1) return;
      e.preventDefault();
      isDragging = true; dragStartX = e.clientX; dragStartY = e.clientY;
      dragOriginX = translateX; dragOriginY = translateY;
      img.style.cursor = 'grabbing'; img.style.transition = 'none';
    });

    document.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      translateX = dragOriginX + (e.clientX - dragStartX);
      translateY = dragOriginY + (e.clientY - dragStartY);
      clampTranslate(); applyTransform(false);
    }, {signal:lifecycle.signal});

    document.addEventListener('mouseup', function () {
      if (!isDragging) return;
      isDragging = false;
      img.style.cursor = scale > 1 ? 'grab' : 'zoom-in';
    }, {signal:lifecycle.signal});

    overlay.addEventListener('wheel', function (e) {
      e.preventDefault();
      var delta = e.deltaY < 0 ? 1.15 : 0.87;
      var newScale = Math.min(maxScale, Math.max(minScale, scale * delta));
      if (newScale === scale) return;
      var rect = img.getBoundingClientRect();
      translateX += (rect.left + rect.width / 2 - e.clientX) * (newScale - scale);
      translateY += (rect.top + rect.height / 2 - e.clientY) * (newScale - scale);
      scale = newScale;
      if (scale <= 1) { scale = 1; translateX = 0; translateY = 0; }
      clampTranslate(); applyTransform(false);
    }, { passive: false });

    overlay.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        isPinching = true; isDragging = false;
        pinchStartDist = getTouchDist(e.touches[0], e.touches[1]);
        pinchStartScale = scale;
        var mid = getTouchMid(e.touches[0], e.touches[1]);
        var rect = img.getBoundingClientRect();
        pinchOriginX = mid.x - (rect.left + rect.width / 2);
        pinchOriginY = mid.y - (rect.top + rect.height / 2);
      } else if (e.touches.length === 1) {
        swipeTouchStartX = e.touches[0].clientX;
        swipeTouchStartY = e.touches[0].clientY;
        if (scale > 1) {
          isDragging = true;
          dragStartX = e.touches[0].clientX; dragStartY = e.touches[0].clientY;
          dragOriginX = translateX; dragOriginY = translateY;
        }
      }
    }, { passive: true });

    overlay.addEventListener('touchmove', function (e) {
      e.preventDefault();
      if (isPinching && e.touches.length === 2) {
        var dist = getTouchDist(e.touches[0], e.touches[1]);
        var newScale = Math.min(maxScale, Math.max(minScale, pinchStartScale * (dist / pinchStartDist)));
        var scaleRatio = newScale / scale;
        translateX = translateX * scaleRatio + pinchOriginX * (scaleRatio - 1);
        translateY = translateY * scaleRatio + pinchOriginY * (scaleRatio - 1);
        scale = newScale; clampTranslate(); applyTransform(false);
      } else if (isDragging && e.touches.length === 1 && scale > 1) {
        translateX = dragOriginX + (e.touches[0].clientX - dragStartX);
        translateY = dragOriginY + (e.touches[0].clientY - dragStartY);
        clampTranslate(); applyTransform(false);
      }
    }, { passive: false });

  overlay.addEventListener('touchend', function (e) {
    if (e.touches.length < 2) isPinching = false;
    if (e.touches.length === 0) {
      isDragging = false;
      if (scale < 1) resetZoom(true);
      // Swipe to navigate only when not zoomed
      if (scale <= 1) {
        var dx = swipeTouchStartX - e.changedTouches[0].clientX;
        var dy = swipeTouchStartY - e.changedTouches[0].clientY;
        if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy)) {
          goTo(dx > 0 ? idx + 1 : idx - 1);
        }
      }
    }
  }, { passive: true });

    img.src = srcs[idx];

    function makeChev(html) {
      var chev = document.createElement('div');
      chev.innerHTML = html;
      chev.style.cssText = 'position:absolute;top:50%;transform:translateY(-50%);font-size:56px;color:#fff;cursor:pointer;user-select:none;padding:0 20px;z-index:10;opacity:0.8;';
      return chev;
    }
    var chevLeft = makeChev('&#8249;');
    chevLeft.style.left = window.innerWidth >= 669 ? '2px' : '-16px';
    var chevRight = makeChev('&#8250;');
    chevRight.style.right = window.innerWidth >= 669 ? '10px' : '-16px';

    function goTo(newIdx) {
      idx = (newIdx + srcs.length) % srcs.length;
      img.src = srcs[idx];
      resetZoom(false);
      chevLeft.style.display = srcs.length > 1 ? '' : 'none';
      chevRight.style.display = srcs.length > 1 ? '' : 'none';
    }

    chevLeft.addEventListener('click', function (e) { e.stopPropagation(); goTo(idx - 1); });
    chevRight.addEventListener('click', function (e) { e.stopPropagation(); goTo(idx + 1); });
    closeBtn.addEventListener('click', function (e) { e.stopPropagation(); cleanupZoom(); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) cleanupZoom(); });

    function escHandler(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        if (scale > 1) { resetZoom(true); }
        else { cleanupZoom(); }
      }
    }
    document.addEventListener('keydown', escHandler, {signal:lifecycle.signal});

    overlay.appendChild(closeBtn);
    overlay.appendChild(chevLeft);
    overlay.appendChild(img);
    overlay.appendChild(chevRight);
    function syncZoomViewport() {
      var viewport = window.visualViewport;
      zoomViewportWidth = viewport?.width || window.innerWidth;
      zoomViewportHeight = viewport?.height || window.innerHeight;
      overlay.style.inset = 'auto';
      overlay.style.left = (viewport?.offsetLeft || 0) + 'px';
      overlay.style.top = (viewport?.offsetTop || 0) + 'px';
      overlay.style.width = zoomViewportWidth + 'px';
      overlay.style.height = zoomViewportHeight + 'px';
      img.style.width = zoomViewportWidth * .88 + 'px';
      img.style.height = zoomViewportHeight * .88 + 'px';
      chevLeft.style.left = zoomViewportWidth >= 669 ? '2px' : '-16px';
      chevRight.style.right = zoomViewportWidth >= 669 ? '10px' : '-16px';
    }
    function onZoomResize() { syncZoomViewport(); clampTranslate(); applyTransform(false); }
    window.addEventListener('resize',onZoomResize,{signal:lifecycle.signal});
    window.addEventListener('orientationchange',onZoomResize,{signal:lifecycle.signal});
    window.visualViewport?.addEventListener('resize',onZoomResize,{signal:lifecycle.signal});
    window.visualViewport?.addEventListener('scroll',syncZoomViewport,{signal:lifecycle.signal});
    [closeBtn,chevLeft,chevRight].forEach(function(control,i) {
      control.setAttribute('role','button'); control.tabIndex = 0;
      control.setAttribute('aria-label',['Close image zoom','Previous image','Next image'][i]);
      control.addEventListener('keydown',function(e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); control.click(); } });
    });
    document.body.appendChild(overlay);
    syncZoomViewport();
    overlay.showModal();
    goTo(idx);
    closeBtn.focus({preventScroll:true});
  }

  async function addToCart() {
    if (!current || submitting || !current.selected.available) return;
    const quantityInput = modal.querySelector('#smqv-quantity');
    const quantity = Number(quantityInput.value);
    if (!Number.isSafeInteger(quantity) || quantity < 1) { quantityInput.reportValidity(); return; }
    const variantId = current.selected.id, productId = current.product.id, token = sequence;
    const button = modal.querySelector('[data-smqv-add]'), status = modal.querySelector('.smqv-response');
    submitting = true; button.disabled = true; button.textContent = 'Adding…';
    try {
      const {CartAddEvent} = await import('@theme/events');
      const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(node => node.dataset.sectionId))].filter(Boolean).slice(0,5);
      const response = await fetch(rootPath + 'cart/add.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(variantId),quantity}],sections,sections_url:location.pathname})});
      const result = await response.json(); if (!response.ok) throw new Error(result.description || 'Could not add this item.');
      const cartResponse = await fetch(rootPath + 'cart.js', {credentials:'same-origin',cache:'no-store'});
      if (!cartResponse.ok) throw new Error('Added, but the cart could not be refreshed. Do not add again.');
      const cart = await cartResponse.json();
      if (token === sequence && modal.open) close();
      document.dispatchEvent(new CartAddEvent(cart,String(variantId),{source:'product-form-component',itemCount:quantity,productId:String(productId),variantId:String(variantId),sections:result.sections}));
    } catch (error) { if (token === sequence) status.textContent = error.message || 'Could not add item.'; }
    finally { submitting = false; if (token === sequence && current) updateVariant(); }
  }
  function handleModalClick(event) {
    const control = event.target.closest('[data-smqv-close],[data-smqv-description],[data-smqv-step],[data-smqv-image],[data-smqv-zoom],[data-smqv-quantity-step],[data-smqv-add],[data-smqv-wishlist]');
    if (!control) return;
    event.preventDefault();
    if (control.hasAttribute('data-smqv-close')) close();
    else if (control.hasAttribute('data-smqv-description')) {
      const expanded = control.getAttribute('aria-expanded') !== 'true';
      control.setAttribute('aria-expanded', String(expanded)); control.textContent = expanded ? 'Hide Description' : 'Click for Description';
      const description = modal.querySelector('.smqv-description__main'); description.hidden = !expanded; description.classList.toggle('no-max-height', expanded);
      modal.querySelector('.smqv-description').classList.toggle('smqv-description--full', expanded);
      syncShortPortraitScroll();
    } else if (control.hasAttribute('data-smqv-step')) selectImage(current.index + Number(control.dataset.smqvStep));
    else if (control.hasAttribute('data-smqv-image')) selectImage(Number(control.dataset.smqvImage));
    else if (control.hasAttribute('data-smqv-zoom')) showZoom();
    else if (control.hasAttribute('data-smqv-quantity-step')) { const input = modal.querySelector('#smqv-quantity'); input.value = Math.max(1,(Number(input.value) || 1) + Number(control.dataset.smqvQuantityStep)); }
    else if (control.hasAttribute('data-smqv-add')) addToCart();
    else if (control.hasAttribute('data-smqv-wishlist')) toggleModalWishlist();
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-smqv-handle]');
    if (!trigger) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const card = trigger.closest('product-card');
    open(trigger.dataset.smqvHandle,card?.dataset.smvfVariantId || card?.dataset.currentVariant || trigger.dataset.smqvVariant,trigger);
  }, true);
  document.addEventListener('keydown', event => { if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('[data-smqv-quantity-step]')) { event.preventDefault(); event.target.click(); } });
})();
(function () {
  const TS_SHOP_ID = '4956749927';
  if (window.__smqvReviewsInstalled) return;
  window.__smqvReviewsInstalled = true;
  const POPOVER_ID = 'smqv-review-popover';
  let lifecycle = null, observer = null, photoDialog = null, frame = 0;
  function getContainer() { return document.getElementById('smqv-root'); }
  function escapeReview(value) { const node = document.createElement('div'); node.textContent = String(value ?? ''); return node.innerHTML; }
  function reviewImage(value) {
    try { const url = new URL(value,location.origin); return url.protocol === 'https:' ? url.href : ''; } catch (_) { return ''; }
  }
  function removePopover() {
    lifecycle?.abort(); lifecycle = null;
    observer?.disconnect(); observer = null;
    cancelAnimationFrame(frame);
    photoDialog?.remove(); photoDialog = null;
    document.getElementById(POPOVER_ID)?.remove();
  }
  function starsHTML(rating) {
    rating = parseFloat(rating) || 0;
    let html = '';
    for (let i = 1; i <= 5; i++) {
      html += `<svg width="13" height="13" viewBox="0 0 32 32" style="fill:${i <= Math.round(rating) ? '#FFB400' : '#ddd'};margin:0 1px;flex-shrink:0"><path d="M31.547 12a.848.848 0 00-.677-.577l-9.427-1.376-4.224-8.532a.847.847 0 00-1.516 0l-4.218 8.534-9.427 1.355a.847.847 0 00-.467 1.467l6.823 6.664-1.612 9.375a.847.847 0 001.23.893l8.428-4.434 8.432 4.432a.847.847 0 001.229-.894l-1.615-9.373 6.822-6.665a.845.845 0 00.214-.869z"/></svg>`;
    }
    return html;
  }
  function showPopover(anchorEl, productId) {
    removePopover();
    const root = getContainer();
    if (!root?.open) return;
    const controller = new AbortController(); lifecycle = controller;
    const signal = controller.signal;
    const anchorRect = anchorEl.getBoundingClientRect();
    const pop = document.createElement('div');
    pop.id = POPOVER_ID;
if (window.innerWidth >= 768) {
  pop.classList.add('smqv-review-popover-ipad');
}
    pop.style.cssText = `
      position: fixed;
      top: ${Math.max(
  8,
  anchorRect.top - (window.innerWidth >= 768 ? 81 : 448)
)}px;
      left: ${anchorRect.left}px;
      z-index: 2147483646;
      background: #fff;
      border: 1px solid #e8e8e8;
      border-radius: 12px;
      box-shadow: 0 12px 40px rgba(0,0,0,0.2);
      width: 340px;
      max-height: min(460px, 86vh);
      display: flex;
      flex-direction: column;
      font-family: inherit;
      overflow: hidden;
      animation: smqv-review-in 0.16s ease;
    `;
    pop.innerHTML = `
      <style>
        @keyframes smqv-review-in {
          from {
            opacity: 0;
            transform: translateY(-6px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      </style>
      <div style="display:flex;align-items:center;justify-content:space-between;padding:10px 16px;border-bottom:1px solid #f0f0f0;flex-shrink:0">
        <span style="font-size:13px;font-weight:700;color:#222">
          Customer Reviews
        </span>
        <button
          id="smqv-review-pop-close"
          style="background:none;border:none;cursor:pointer;font-size:22px;color:#aaa;line-height:1;padding:0"
        >
          ×
        </button>
      </div>
      <div id="smqv-review-pop-summary" style="flex-shrink:0"></div>
      <div
        id="smqv-review-pop-body"
        style="overflow-y:auto;flex:1"
      >
        <div style="text-align:center;padding:24px;color:#bbb;font-size:12px">
          Loading reviews…
        </div>
      </div>
    `;
    root.appendChild(pop);
    positionReviewPopup(pop,anchorEl);
    const reposition = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => { if (pop.isConnected) positionReviewPopup(pop,anchorEl); });
    };
    window.addEventListener('resize',reposition,{signal});
    window.visualViewport?.addEventListener('resize',reposition,{signal});
    window.visualViewport?.addEventListener('scroll',reposition,{signal});
    if (window.ResizeObserver) {
      observer = new ResizeObserver(reposition);
      observer.observe(pop);
      const box = root.querySelector('.smqv-modal-box'); if (box) observer.observe(box);
    }
    root.addEventListener('close',removePopover,{signal});
    root.addEventListener('cancel',event => { event.preventDefault(); event.stopImmediatePropagation(); removePopover(); },{capture:true,signal});
    pop.setAttribute('role','dialog'); pop.setAttribute('aria-label','Customer Reviews'); pop.tabIndex = -1;
    pop.style.outline = 'none'; pop.focus({preventScroll:true});
    pop.querySelector('#smqv-review-pop-close').type = 'button';
    pop.querySelector('#smqv-review-pop-close').setAttribute('aria-label','Close reviews');
    pop.addEventListener('click',event => {
      const image = event.target.closest('#smqv-review-pop-body img');
      if (image) { event.preventDefault(); event.stopPropagation(); showReviewPhoto(image.src); }
    });

    pop
      .querySelector('#smqv-review-pop-close')
      .addEventListener('click', removePopover);
    const summaryEl = pop.querySelector('#smqv-review-pop-summary');
    const bodyEl = pop.querySelector('#smqv-review-pop-body');
    const base = 'https://storefront.trustshop.io/storefront/page';
    Promise.all([
      fetch(
        `${base}/summary?shop_id=${TS_SHOP_ID}&product_ids=${encodeURIComponent(productId)}`, {signal}
      )
        .then(r => r.json())
        .catch(() => null),
      fetch(
        `${base}/reviews?shop_id=${TS_SHOP_ID}&product_ids=${encodeURIComponent(productId)}`, {signal}
      )
        .then(r => r.json())
        .catch(() => null)
    ]).then(([summary, reviewsData]) => {
      if (signal.aborted || !pop.isConnected) return;
      if (!summary && !reviewsData) throw new Error('Reviews unavailable');
      if (summary) {
        const avg = parseFloat(summary.average_review || 0);
        const stars = summary.stars_review || {};
        const total = Number(summary.total_review) || 0;
        const bar = n => {
          const pct = total
            ? Math.round(((stars['star_' + n] || 0) / total) * 100)
            : 0;
          return `
            <div style="flex:1;height:5px;background:#f0f0f0;border-radius:3px;overflow:hidden">
              <div style="width:${pct}%;height:100%;background:#FFB400;border-radius:3px"></div>
            </div>
          `;
        };
        summaryEl.innerHTML = `
          <div style="display:flex;align-items:center;gap:12px;padding:6px 12px;background:#fafafa;border-bottom:1px solid #f0f0f0">
            <div style="text-align:center;flex-shrink:0">
              <div style="font-size:22px;font-weight:700;color:#222;line-height:1">
                ${avg.toFixed(1)}
              </div>
              <div style="display:flex;margin:2px 0 1px">
                ${starsHTML(avg)}
              </div>
              <div style="font-size:11px;color:#999">
                ${total} review${total !== 1 ? 's' : ''}
              </div>
            </div>
            <div style="flex:1;display:flex;flex-direction:column;gap:3px">
              ${[5, 4, 3, 2, 1]
                .map(
                  n => `
                    <div style="display:flex;align-items:center;gap:5px">
                      <span style="font-size:10px;color:#666;width:6px;flex-shrink:0">
                        ${n}
                      </span>
                      <svg
                        width="9"
                        height="9"
                        viewBox="0 0 32 32"
                        style="fill:#FFB400;flex-shrink:0"
                      >
                        <path d="M31.547 12a.848.848 0 00-.677-.577l-9.427-1.376-4.224-8.532a.847.847 0 00-1.516 0l-4.218 8.534-9.427 1.355a.847.847 0 00-.467 1.467l6.823 6.664-1.612 9.375a.847.847 0 001.23.893l8.428-4.434 8.432 4.432a.847.847 0 001.229-.894l-1.615-9.373 6.822-6.665a.845.845 0 00.214-.869z"/>
                      </svg>
                      ${bar(n)}
                      <span style="font-size:10px;color:#999;width:14px;text-align:right;flex-shrink:0">
                        ${Number(stars['star_' + n]) || 0}
                      </span>
                    </div>
                  `
                )
                .join('')}
            </div>
          </div>
        `;
      }
      const reviews = reviewsData?.data || [];
      if (!reviews.length) {
        bodyEl.innerHTML = `
          <div style="text-align:center;padding:20px;font-size:12px;color:#999">
            No reviews yet.
          </div>
        `;
        return;
      }
      let visibleReviewCount = 8;

      const renderVisibleReviews = () => {
        bodyEl.innerHTML = reviews
          .slice(0, visibleReviewCount)
        .map(r => {
          const rating =
            r.rating ??
            r.star ??
            r.stars ??
            r.score ??
            r.note ??
            null;
          const date = r.created_at
            ? new Date(r.created_at).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
              })
            : '';
          return `
            <div style="padding:12px 16px;border-bottom:1px solid #f5f5f5">
              <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:4px">
                <div style="display:flex;align-items:center;gap:6px">
                  ${
                    rating
                      ? `<div style="display:flex">${starsHTML(rating)}</div>`
                      : ''
                  }
                  ${
                    r.buyer_verification
                      ? `<span style="font-size:10px;background:#e8f5e9;color:#2e7d32;padding:1px 7px;border-radius:10px">✓ Verified</span>`
                      : ''
                  }
                </div>
                <span style="font-size:11px;color:#bbb">
                  ${date}
                </span>
              </div>
              ${
                r.title
                  ? `<div style="font-size:13px;font-weight:600;color:#222;margin-bottom:3px">${escapeReview(r.title)}</div>`
                  : ''
              }
              <div style="font-size:12px;color:#444;line-height:1.6">
                ${escapeReview(String(r.content || '').substring(0, 300))}
                ${(r.content || '').length > 300 ? '…' : ''}
              </div>
              ${(() => {
                const imageMedias =
                  r.medias?.filter(
                    m =>
                      m.type === 'image' ||
                      m.url?.match(
                        /\.(jpg|jpeg|png|webp|gif)(\?|$)/i
                      )
                  ) || [];
                return imageMedias.length
                  ? `
                    <div style="display:flex;gap:6px;flex-wrap:wrap;margin-top:8px">
                      ${imageMedias
                        .map(
                          m => `
                            <img
                              src="${escapeReview(reviewImage(m.url))}"
                              style="width:56px;height:56px;object-fit:cover;border-radius:6px;border:1px solid #eee;cursor:pointer"
                              loading="lazy"
                            >
                          `
                        )
                        .join('')}
                    </div>
                  `
                  : '';
              })()}
              <div style="font-size:11px;color:#999;margin-top:4px">
                ${escapeReview(r.customer?.name || 'Customer')}
              </div>
            </div>
          `;
        })
        .join('');

        if (visibleReviewCount < reviews.length) {
          const loadMoreButton = document.createElement('button');

          loadMoreButton.type = 'button';
          loadMoreButton.textContent = 'Load More Reviews';

          loadMoreButton.style.cssText = `
            display:block;
            width:calc(100% - 32px);
            margin:12px 16px 16px;
            padding:10px 14px;
            border:1px solid #ddd;
            border-radius:6px;
            background:#fff;
            color:#222;
            font-family:inherit;
            font-size:12px;
            font-weight:600;
            cursor:pointer;
          `;

          loadMoreButton.addEventListener('click', () => {
            visibleReviewCount += 8;
            renderVisibleReviews();

            requestAnimationFrame(() => {
              bodyEl.scrollTop = bodyEl.scrollHeight;
            });
          });

          bodyEl.appendChild(loadMoreButton);
        }
      };

      renderVisibleReviews();
    }).catch(() => {
      if (signal.aborted || !pop.isConnected) return;
      bodyEl.innerHTML = `
        <div style="text-align:center;padding:20px;font-size:12px;color:#999">
          Couldn't load reviews.
        </div>
      `;
    });
  }
  function positionReviewPopup(pop,anchor) {
    const viewport = window.visualViewport;
    const width = viewport?.width || window.innerWidth;
    const height = viewport?.height || window.innerHeight;
    const originX = viewport?.offsetLeft || 0;
    const originY = viewport?.offsetTop || 0;
    const maxHeight = Math.min(460,height-16);
    pop.style.width = Math.min(340,width-16)+'px';
    pop.style.maxHeight = maxHeight+'px';
    const rect = anchor.getBoundingClientRect();
    const popRect = pop.getBoundingClientRect();
    const popupHeight = popRect.height || maxHeight;
    const portraitPhone = window.matchMedia('(max-width:599px) and (orientation:portrait)').matches;
    const desiredLeft = portraitPhone ? originX+(width-popRect.width)/2 : rect.left;
    const left = Math.max(originX+8,Math.min(desiredLeft,originX+width-popRect.width-8));
    const isTabletOrLarger = window.matchMedia('(min-width:600px) and (min-height:600px)').matches;
    const isPortrait = window.matchMedia('(orientation:portrait)').matches;
    const portraitReviewOffset = 310;
    const landscapeReviewOffset = 210;
    const tabletDesktopOffset = isTabletOrLarger
      ? (isPortrait ? portraitReviewOffset : landscapeReviewOffset)
      : 0;
    const minTop = originY + 8;
    const maxTop = Math.max(minTop, originY + height - popupHeight - 8);
    const baseTop = Math.max(minTop, Math.min(rect.top - popupHeight - 8, maxTop));
    const top = Math.min(baseTop + tabletDesktopOffset, maxTop);
    pop.style.left = left+'px'; pop.style.top = top+'px';
  }
  function showReviewPhoto(source) {
    const src = reviewImage(source); if (!src) return;
    photoDialog?.remove();
    const dialog = document.createElement('dialog'); photoDialog = dialog;
    dialog.setAttribute('aria-label','Review photo');
    dialog.style.cssText = 'position:fixed;inset:0;border:0;padding:16px;margin:0;width:100vw;height:100dvh;max-width:none;max-height:none;background:rgba(0,0,0,.9);display:flex;align-items:center;justify-content:center;';
    const image = document.createElement('img'); image.src = src; image.alt = 'Customer review photo';
    image.style.cssText = 'display:block;max-width:90vw;max-height:90dvh;width:auto;height:auto;object-fit:contain;border-radius:8px;';
    const close = document.createElement('button'); close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label','Close review photo');
    close.style.cssText = 'position:absolute;top:12px;right:16px;width:36px;height:36px;border:0;border-radius:50%;background:#fff;color:#111;font-size:26px;cursor:pointer;';
    function dismiss(event) {
      event?.preventDefault(); event?.stopPropagation();
      dialog.close(); dialog.remove(); if (photoDialog === dialog) photoDialog = null;
    }
    close.addEventListener('click',dismiss);
    dialog.addEventListener('click',event => { if (event.target === dialog) dismiss(event); });
    dialog.addEventListener('cancel',dismiss);
    dialog.append(image,close); document.body.appendChild(dialog); dialog.showModal();
  }
  function activateReviews(control) {
    const root = getContainer();
    if (!root?.open || !root.contains(control)) return;
    if (document.getElementById(POPOVER_ID)) { removePopover(); return; }
    const productId = control.querySelector('[product-id]')?.getAttribute('product-id');
    if (productId) showPopover(control,productId);
  }
  window.addEventListener('click',event => {
    if (photoDialog?.contains(event.target)) return;
    const control = event.target.closest('[data-smqv-rating]');
    const root = getContainer();
    if (control && root?.open && root.contains(control)) {
      event.preventDefault(); event.stopImmediatePropagation(); activateReviews(control); return;
    }
    const pop = document.getElementById(POPOVER_ID);
    if (pop && !pop.contains(event.target)) removePopover();
  },true);
  window.addEventListener('keydown',event => {
    const control = event.target.closest('[data-smqv-rating]');
    if (control && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault(); event.stopImmediatePropagation(); activateReviews(control);
    }
  },true);
})();


/* SlickMod QuickView: iWish page integration */
(() => {
  'use strict';
  if (!/(?:\/apps\/iwish|\/wishlist)(?:\/|$)/.test(location.pathname)) return;
  if (window.__smqvWishlistBridgeR1) return;
  window.__smqvWishlistBridgeR1 = true;

  function syncButton(card, button) {
    const link = card.querySelector('.iwishMeta-title a[href], .iwishImgWrap a[href]');
    if (!link) return false;
    let url;
    try { url = new URL(link.href, location.origin); } catch (_) { return false; }
    const match = url.pathname.match(/\/products\/([^/]+)/);
    if (!match) return false;
    let handle;
    try { handle = decodeURIComponent(match[1]); } catch (_) { return false; }
    const input = card.querySelector('input[name="id"]');
    const quantity = card.querySelector('.iwishQtyInput[data-variant]');
    const variant = input?.value || quantity?.dataset.variant || url.searchParams.get('variant') || '';
    if (button.dataset.smqvHandle !== handle) button.dataset.smqvHandle = handle;
    if (button.dataset.smqvVariant !== String(variant)) button.dataset.smqvVariant = String(variant);
    return true;
  }

  function refresh() {
    document.querySelectorAll('.iwishItem').forEach(card => {
      const wrap = card.querySelector('.iwishImgWrap');
      if (!wrap) return;
      let button = wrap.querySelector('[data-smqv-wishlist-trigger]');
      if (button) { syncButton(card, button); return; }
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'smqv-card-trigger smqv-wishlist-trigger';
      button.setAttribute('data-smqv-wishlist-trigger', '');
      button.setAttribute('aria-label', 'Quick view');
      button.title = 'Quick view';
      button.style.cssText = 'position:absolute;top:4px;right:5px;z-index:5;display:flex;align-items:center;justify-content:center;box-sizing:border-box;width:35px;height:35px;min-width:35px;min-height:35px;padding:8px;margin:0;border:0;border-radius:50%;background:#fff;color:#111;cursor:pointer;opacity:1;visibility:visible;pointer-events:auto;';
      button.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true" style="pointer-events:none"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/></svg>';
      if (!syncButton(card, button)) return;
      if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
      wrap.appendChild(button);
    });
  }

  // Refresh the selected variant before the existing document click handler runs.
  window.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-smqv-wishlist-trigger]');
    const card = button?.closest('.iwishItem');
    if (card) syncButton(card, button);
  }, true);

  function start() {
    refresh();
    let scheduled = false;
    const observer = new MutationObserver(records => {
      const relevant = records.some(record => {
        const target = record.target instanceof Element ? record.target : record.target.parentElement;
        if (target?.closest('#smqv-root, [data-smqv-wishlist-trigger]')) return false;
        if (record.type === 'attributes') return !!target?.closest('.iwishItem');
        return Array.from(record.addedNodes).some(node => node instanceof Element && (node.matches('.iwishItem, .iwishProducts, .iwishWrapper') || node.querySelector('.iwishItem'))) || !!target?.closest('.iwishItem');
      });
      if (!relevant || scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; refresh(); });
    });
    observer.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['href','data-variant','value']});
    document.addEventListener('change', event => {
      if (event.target instanceof Element && event.target.closest('.iwishItem')) requestAnimationFrame(refresh);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();


/* One shared reveal state for mouse, touch and pen. Never cancel card navigation. */
(() => {
  'use strict';
  if (window.__smqvSingleRevealR3) return;
  window.__smqvSingleRevealR3 = true;
  const style = document.createElement('style');
  style.id = 'smqv-single-reveal-r3';
  style.textContent = `
    :root product-card .smqv-card-trigger,
    :root .iwishItem .smqv-card-trigger {
      opacity:0!important;visibility:hidden!important;pointer-events:none!important;
    }
    :root product-card.smqv-single-active .smqv-card-trigger,
    :root .iwishItem.smqv-single-active .smqv-card-trigger {
      opacity:1!important;visibility:visible!important;pointer-events:auto!important;
    }
    :root .smqv-card-trigger[data-smqv-loading="true"] {pointer-events:none!important;}
  `;
  document.head.appendChild(style);
  let active = null;
  let lastTouch = -Infinity;
  function cardAt(target, event) {
    if (!(target instanceof Element)) return null;
    if (target.closest('#smqv-root,#smqv-zoom')) return null;

    const card = target.closest('product-card,.iwishItem');
    if (!card?.querySelector('.smqv-card-trigger')) return null;

    // Keep the eye usable, including with keyboard focus.
    if (target.closest('.smqv-card-trigger')) return card;

    // Swatches and other controls must not reveal QuickView.
    if (target.closest(
      'button,input,select,textarea,label,fieldset,' +
      '[role="radio"],[role="radiogroup"],[role="button"],' +
      'swatches-component,variant-picker,.swatch,.swatches'
    )) return null;

    if (!event || !Number.isFinite(event.clientX) ||
        !Number.isFinite(event.clientY)) return null;

    // Reveal only when the pointer is inside a visible product image.
    const overImage = Array.from(card.querySelectorAll('img')).some(img => {
      if (img.closest(
        'button,label,fieldset,swatches-component,variant-picker,' +
        '.swatch,.swatches,[role="radiogroup"]'
      )) return false;

      const rect = img.getBoundingClientRect();
      const style = getComputedStyle(img);

      return rect.width > 0 &&
        rect.height > 0 &&
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        Number(style.opacity) !== 0 &&
        event.clientX >= rect.left &&
        event.clientX < rect.right &&
        event.clientY >= rect.top &&
        event.clientY < rect.bottom;
    });

    return overImage ? card : null;
  }
  function activate(card) {
    if (active === card) return;
    active?.classList.remove('smqv-single-active');
    active = card;
    active?.classList.add('smqv-single-active');
  }
    document.addEventListener('pointerover', event => {
    if (event.pointerType !== 'mouse' || performance.now()-lastTouch < 800) return;
    activate(cardAt(event.target, event));
  }, {passive:true});

  document.addEventListener('pointerout', event => {
    if (event.pointerType !== 'mouse' || !active) return;
    if (!(event.target instanceof Node) || !active.contains(event.target)) return;
    if (event.relatedTarget instanceof Node && active.contains(event.relatedTarget)) return;
    activate(null);
  }, {passive:true});

  document.addEventListener('pointerdown', event => {
    if (event.pointerType === 'touch' || event.pointerType === 'pen') lastTouch = performance.now();
    if (event.target instanceof Element && event.target.closest('#smqv-root,#smqv-zoom')) return;
    activate(cardAt(event.target, event));
  }, {capture:true,passive:true});

  document.addEventListener('focusin', event => {
    if (event.target instanceof Element && event.target.matches('.smqv-card-trigger:focus-visible')) {
      activate(cardAt(event.target, event));
    }
  });

  window.addEventListener('blur', () => activate(null));
})();
